import { FC } from 'react'

import { useSuspenseQuery } from '@tanstack/react-query'

import { Cluster, Icon, Stack, Typography } from '@forto-dev/phoenix-ui-core'
import { Widget, WidgetFooter, WidgetHeader, WidgetTitle } from '@forto-dev/phoenix-ui-core/ship'

import { useLocalisation } from '@/utils/localisation'

import { getFilteredQuoteSheetsByFilterType, ManualQuoteListFilterType } from '../api/manual-quotes.service'
import { manualQuotesQueryOptions } from '../api/useManualQuotes'

export const QuotesSidebar: FC = () => {
  const { translate } = useLocalisation()
  const quotes = useSuspenseQuery(manualQuotesQueryOptions())
  const pending = getFilteredQuoteSheetsByFilterType(quotes.data ?? [], ManualQuoteListFilterType.PENDING).length
  const declined = getFilteredQuoteSheetsByFilterType(quotes.data ?? [], ManualQuoteListFilterType.DECLINED).length

  return (
    <Stack gap={16}>
      {pending > 0 ? (
        <Widget variant="primary">
          <WidgetHeader>
            <WidgetTitle>{translate('quotes.pending')}</WidgetTitle>
          </WidgetHeader>
          <WidgetFooter>
            <Cluster gap={4} y="center">
              <Icon size="md" name="Warning" />
              <Typography variant="h3">{pending}</Typography>
            </Cluster>
          </WidgetFooter>
        </Widget>
      ) : null}
      {declined >= 0 ? (
        <Widget variant="neutral">
          <WidgetHeader>
            <WidgetTitle>{translate('quotes.declined')}</WidgetTitle>
          </WidgetHeader>
          <WidgetFooter>
            <Cluster gap={4} y="center">
              <Icon size="md" name="Warning" />
              <Typography variant="h3">{declined}</Typography>
            </Cluster>
          </WidgetFooter>
        </Widget>
      ) : null}
    </Stack>
  )
}
